// Add to session (SI-25): the web has no open session to drop a sound
// into, so the sound's full-quality WAV is staged in New session, which
// names the session after it and uploads it on Start (as PackPage did).
//   canAddToSession(sound)  free or owned, or buyable and not yours
//   addToSession(sound)     signed out: sign up first; buyable: the buy
//                           sheet; else fetch the WAV and stage it
import store from "@/store";
import router from "@/router";
import { canBuy, canDownload, soundFileName } from "@/kit/sound.js";
import { getWavDownloadFromProxyWithId } from "@/filters/utils";
import { soundSheets } from "@/shell/soundSheets.js";
import { toast } from "@/shell/toast.js";

export function canAddToSession(sound) {
  if (!sound) return false;
  return canDownload(sound) || (canBuy(sound) && !sound.mine);
}

export async function addToSession(sound) {
  if (!sound) return false;
  if (!store.state.loggedInUser) {
    const here = router.currentRoute.value;
    router.push({ path: "/sign-up", query: { redirect: here ? here.fullPath : "/" } }).catch(() => {});
    return false;
  }
  if (!canDownload(sound)) {
    if (canBuy(sound)) soundSheets.open("buy", sound);
    return false;
  }
  try {
    const res = await fetch(getWavDownloadFromProxyWithId(sound.hash, sound.downloadToken), {
      credentials: "include",
    });
    if (!res.ok) throw new Error(String(res.status));
    const blob = await res.blob();
    const file = new File([blob], soundFileName(sound), { type: "audio/wav" });
    await store.dispatch("stageNewSessionAudio", [file]);
    return true;
  } catch (e) {
    console.error("Add to session failed", e);
    toast(`Couldn't get ${sound.title}. Try again.`);
    return false;
  }
}

export default { canAddToSession, addToSession };
